module.exports = __webpack_public_path__ + "static/media/coneeds-team.5269b25c.jpg";